import React from "react";
import { useDispatch } from "react-redux";
import { get_credietitial } from "./JSfiles/Login_js";

import "./style/login.css";

const Login = () => {
  const dispatch = useDispatch({});

  return (
      <>
          <div className="login-wrapper">
                <div className="login-page" >
                <div>
                    <div className="logo-section">
                        <img src="assets/images/amanrow-logo.png" alt="d" />
                    </div>
                    <div className="login-section">              
                    <div className="login-container">
                    <div className="text-center">
                        <h5 className="login-text">Login</h5>
                    </div>
                    <div className="login-form">
                        <div className="login-icon">
                        <i className="bi bi-person"></i>
                        </div><input id="user_name" type="text" className="form-control login-input" placeholder="Username"/></div>
                    <div className="login-form">
                        <div className="login-icon">
                        <i className="bi bi-key"></i>
                        </div>
                        <input
                        id="user_password"
                        type="password"
                        className="form-control login-input"
                        placeholder="password"
                        />
                    </div>
                    <div className="login-form text-center">
                        <button
                        className="btn login-btn"
                        onClick={() => {
                            get_credietitial(dispatch);
                        }}
                        >
                        Sign In <i className="bi bi-arrow-right"></i>
                        </button>
                    </div>
                    <div className="my-5">
                        <h6 className="text-center login-msg-text">
                        <div>If you don't have login,</div>
                        <div>
                            {" "}
                            please register{" "}
                            <a href="#" target="_blank" className="">
                            here
                            </a>{" "}
                        </div>
                        </h6>
                    </div>
                    <div className="my-3 text-center">
                        <div>
                        By{" "}
                        <a href="#" className="text-copyrights">
                            itegritypro.com
                        </a>
                        </div>
                    </div>
                    </div>
                </div>
                </div>
              </div>
          </div>
    </>
  );
};

export default Login;
